import { render, staticRenderFns } from "./admin-perguntas.vue?vue&type=template&id=232c9862&"
import script from "./admin-perguntas.vue?vue&type=script&lang=js&"
export * from "./admin-perguntas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports